<template>
  <div class="referred">
    <v-card-text >
        <div class="req-list" >
          <label style="color: darkred">قبل از  سفارش قطعه، برای درخواست وضعیت (اعلام هزینه به مشتری) و همچنین وضعیت (در انتظار قطعه) را ثبت نمایید</label>

          <div class="req-card" style="padding: 5px"  v-for="item in request_items" :key="item.Id">
            <div>
              <div class="flex-no-wrap justify-space-between">
                <div>
                 <div class="row">
                   <div class="col-6">
                     <div
                       class="req-name"
                       v-text="item.BranchName"
                     ></div>
                   </div>
                   <div class="col-6">
                     <div
                       class="req-name"
                       v-text="item.SubmitTime"
                     ></div>
                   </div>
                 </div>
                  <div class="req-name">
                    {{ item.CostCenterName }}
                  </div>
                  <div class="req-name">
                    {{ item.CatTitle }}
                  </div>
<!--                   <div class="req-name">{{item.StatusName}}</div>-->
                   <div class="req-name">{{item.Summary}}</div>
                   <div class="req-name" style="color:#f34e5b">{{item.StatusTitle}}</div>
                  <hr>
                  <v-row v-for="pro in item.Products">
                    <v-col cols="8">{{pro.ProductName}}</v-col>
                    <v-col cols="4">{{pro.Qty}} عدد</v-col>

                    <v-col cols="6">قیمت خرید : {{pro.PurchaseAmount}}</v-col>
                    <v-col cols="6">قیمت فروش : {{pro.SaleAmount}} </v-col>
                    <hr>

                  </v-row>
                </div>

              </div>

            </div>

          </div>

        </div>
      <v-row>
        <v-btn style="bottom: 0;position: absolute;width: 100%" color="primary enter-btn" v-on:click="dialog_factor=true">{{ $t('add_product_request') }}</v-btn>
      </v-row>

      <infinite-loading @infinite="infiniteHandler" v-if="show_loading">
        <div slot="no-more">{{ $t('no_record') }}</div>
      </infinite-loading>

    </v-card-text>
    <v-row justify="center">
      <v-dialog
        v-model="dialog_factor"
        persistent
        fullscreen
        hide-overlay
      >

        <v-card class="category-modal">
          <v-card-title class="headline">{{ $t('add_product_request') }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-form>
                <v-select
                  v-if="$route.params.rec_id==0"
                  :items="category_items"
                  :label="$t('category')"
                  single-line
                  item-text="label"
                  item-value="value"
                  v-model="selected_category"
                />
                <v-select
                  :items="post_items"
                  :label="$t('branch')"
                  single-line
                  item-text="label"
                  item-value="value"
                  v-model="selected_branch"
                />

                <treeselect v-if="selected_category==3"
                  :multiple="false"
                  :load-options="load_requests"
                  :normalizer="normalizer_requests"
                  :async="true"

                  :placeholder="$t('search_request')"
                  v-model="selected_request"
                />
                <treeselect  v-if="selected_category==4"
                  :multiple="false"
                  :load-options="load_persons"
                  :normalizer="normalizer_persons"
                  :async="true"

                  :placeholder="$t('search_user')"
                  v-model="selected_user"
                />

            <br>
            <br>
            <br>
                <v-text-field
                  :label="$t('summary')"
                  v-model="request_summary"
                  outlined
                ></v-text-field>
              </v-form>

            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="cancle-btn"
              text
              @click="dialog_factor = false"
            >{{ $t('cancel') }}</v-btn>
            <v-btn
              class="accept-btn"
              text
              @click="goToItems()"
            >{{ $t('ok') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  import { bus } from '../../main'

  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }

  export default {
    props:[
      'passing_data'
    ],

    data () {
      return {
        list: [],
        errors: [],
        post_items:[],
        selected_post:0,
        dialog_factor:false,
        selected_branch:0,
        request_items:[],
        last_request_items:[],
        show_loading: false,
        page: 0,
        request_summary: '',
        selected_request:null,
        selected_user:null,
        category_items:[],
        selected_category:0,
        normalizer_requests (node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
        normalizer_persons (node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
      Treeselect
    },
    watch: {
      selected_category:function (val) {
        this.selected_request = null
        this.selected_user = null
      }
    },
    mounted () {
      this.get_pre_requests()
      this.get_categories()
      this.get_posts()
    },

    methods: {
      load_requests ({ action, searchQuery, callback }) {
        this.model_txt = searchQuery
        var self = this
        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options

            var user_id = JSON.parse(localStorage.getItem('profile')).UserId
            const send_data = {
              Txt: searchQuery,
              ExpertId: user_id,
              BranchId: self.selected_branch,
            }
            this.axios.post('/GetUserDevicesByTxt', send_data, {})
              .then(response => {
                self.search_entries = response.data.results
                options = response.data.data
                callback(null, options)
                // this.$router.push({ path: "/post-login", params: {} });
              }).catch(e => {
              this.errors.push(e)
            })
          })
        }
      },

      load_persons ({ action, searchQuery, callback }) {
        this.model_txt = searchQuery
        var self = this
        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options
            var user_id = JSON.parse(localStorage.getItem('profile')).UserId

            const send_data = {
              Txt:searchQuery,
              UserId:user_id
            }
            this.axios.post('/GetUsersByTxt', send_data, {})
              .then(response => {
                // self.search_entries = response.data.Payks
                options = response.data.Payks
                callback(null, options)
                // this.$router.push({ path: "/post-login", params: {} });
              }).catch(e => {
              this.errors.push(e)
            })
          })
        }
      },

      get_posts () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetBranches', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              response.data.branches.forEach(function (number) {
                var obj = { label: number.BranchName, value: number.Id }
                self.post_items.push(obj)
              })
              self.get_branch_by_post()
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_branch_by_post () {
        var self = this
        const send_data = {
          PartyId: localStorage.getItem('party_id'),
        }
        this.axios.post('/GetBranchIdByPartyId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.selected_branch = response.data.branchId
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },

      goToDetail (item) {
        var passing_data = {
          category:this.selected_category,
          user:this.selected_user,
          request:this.selected_request,
          branch:this.selected_branch,
          summary:this.request_summary,
        }
        // var passing_data = JSON.parse(localStorage.getItem('request_data'));
        // passing_data.cat_id = item_id;
        localStorage.setItem("request_product",JSON.stringify(passing_data));
        console.log(passing_data)
        this.dialog_factor = false
        this.$router.push({ name: 'ProductRequestFactorItems', params: {rec_id:item.Id} })
      },
      goToItems (item) {
        if (this.selected_branch == 0) {
          bus.$emit('show_toast', [1500, this.$t('please_select_branch')])
          return false
        }
        if (this.selected_category == 0 && this.$route.params.rec_id==0) {
          bus.$emit('show_toast', [1500, this.$t('select_category')])
          return false
        }
        if (this.selected_category == 3 && this.selected_request == null) {
          bus.$emit('show_toast', [1500, this.$t('select_request')])
          return false
        }
        if (this.selected_category == 4 && this.selected_user == null) {
          bus.$emit('show_toast', [1500, this.$t('select_user')])
          return false
        }
        var passing_data;
        if(this.$route.params.rec_id==0){
           passing_data = {
            category:this.selected_category,
            user:this.selected_user,
            request:this.selected_request,
            branch:this.selected_branch,
            summary:this.request_summary,
          }
        }else{
           passing_data = {
            category:3,
            user:this.selected_user,
            request:this.$route.params.rec_id,
            branch:this.selected_branch,
            summary:this.request_summary,
          }
        }

        // var passing_data = JSON.parse(localStorage.getItem('request_data'));
        // passing_data.cat_id = item_id;
        localStorage.setItem("request_product",JSON.stringify(passing_data));
        console.log(passing_data)
        this.dialog_factor = false
        this.$router.push({ name: 'ProductRequestFactorItems', params: {rec_id:0} })
      },
      get_pre_requests ($state) {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          Count: this.page,
          CostCenterId: this.$route.params.rec_id,
        }
        console.log('pre request called')
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetGoodsReqByReqId', send_data, {})
          .then(response => {
            self.request_items = []
            if (response.data.error == 0) {
              response.data.items.forEach(function (number) {
                self.request_items.push(number)
              })
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_categories () {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          Count: this.page,
          CostCenterId: 0,
        }
        console.log('pre request called')
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetProductRequestCategories', send_data, {})
          .then(response => {
            self.category_items = []
            if (response.data.error == 0) {
              response.data.items.forEach(function (number) {
                console.log(number)
                var obj = { label: number.RecTitle, value: number.RecId }
                self.category_items.push(obj)
              })
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      infiniteHandler ($state) {
        var self = this
       if (this.first) {
         // $state.loaded();
         setTimeout(() => {
           $state.loaded()
         }, 1000)
         return false
       }

        console.log('hiii' + self.last_request_items.length)
        setTimeout(() => {
          // if (self.last_request_items>0 ) {
            self.page += 1
            self.get_pre_requests($state)
            // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
          }, 1000)
        },
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
